import {lemmata} from "./lemmata";
import {useEffect, useRef, useState} from "react";

export default function DictLemmata({setLemmaQueryInput}) {

const [display, setDisplay] = useState(false);
const [options, setOptions] = useState([]);
const [search, setSearch] = useState('');
const wrapperRef = useRef(null)



useEffect(()=> {

    const cyrLemmata = []
    const latLemmata = []


    for (let item of lemmata) {
    latLemmata.push(item["lemma"])
    cyrLemmata.push(item["cyr"])

      }
    setOptions(latLemmata.concat(cyrLemmata))

}, [])

    const setWord = word => {
    setSearch(word)
    setDisplay(false)
    }

    const handleClickOutside = (event) => {
     const {current: wrap} = wrapperRef;
     if (wrap && !wrap.contains(event.target)) {
         setDisplay(false)
     }
    }

useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
        document.removeEventListener("mousedown", handleClickOutside)
    }
}, []);

useEffect(() => {

    if (lemmata.filter((word) => word['cyr'] === search)[0]) {
        let item = lemmata.filter((word) => word['cyr'] === search)[0]
        setLemmaQueryInput(item['lemma'])
    }
    else {
        setLemmaQueryInput(search)
    }


}, [search])

return(
    <>
        <div ref={wrapperRef} className="flex-container flex-column pos-rel">
            <input id="auto"
                   placeholder='*type your query here'
                   onChange={(event)=> {
                       setSearch(event.target.value)
                        setDisplay(true)
                   }}
                   value={search}
                   style={{
                    width: "300px",
                       height: "27px"}}
                        />

            {display && (
                <div className='autoContainer'>
                    {options.filter((word) => word.startsWith(search.toLowerCase()))
                        .map((v, i) => {
                        return <div
                            onClick={() => setWord(v)}
                            className='option'
                            key={i}
                            tabIndex="0"
                        ><
                                span><b>{v}</b></span>
                        </div>
                    })}
                </div>
            )}
        </div>
    </>
)

}